"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tab_1 = __importDefault(require("@mui/material/Tab"));
function LinkTab(props) {
    return react_1.default.createElement(Tab_1.default, { ...props });
}
exports.default = LinkTab;
